import {html} from 'lit-html';
import {repeat} from 'lit-html/directives/repeat';
import {unsafeHTML} from 'lit-html/directives/unsafe-html';
import {ifDefined} from 'lit-html/directives/if-defined';
import {live} from 'lit-html/directives/live';
import {classMap} from 'lit-html/directives/class-map';

import TemplateRegistry from '../template/template-registry';
import {ThemeCurrency} from '../const';
import {
    controllerMultiSelect, optionValueText, optionValueClassMap, optionClassMap, 
    optionName, optionQuantityInput
} from '../template/template-util.js';

TemplateRegistry.templates['checkbox'] = (option, config, onChange) => {

    // get or create multi select controller
    option._controller = option._controller || controllerMultiSelect(option, config, onChange);

    return html`
        <input type="hidden" name="${optionName(option)}" id="${option.id}" value=${option.value} form=${ifDefined(config.productFormLink)} />
        ${repeat(option.values || [], (optionValue) => optionValue.value,(optionValue,index) => html`
        <label class="cl-po--checkbox-item ${classMap(optionValueClassMap(option, optionValue))}">
            <input type="checkbox" class="cl-po--input ${classMap(optionClassMap(option))}" id="${option.id}-${index}" .value=${optionValue.value} @change=${(e) => option._controller.onChange(e, option)}
                   .checked=${live(option._controller.isSelected(option,optionValue))} ?disabled=${optionValue.disabled} form=${ifDefined(config.productFormLink)}>
            ${unsafeHTML(optionValueText(option, optionValue, ThemeCurrency.moneyFormat))}
            ${optionQuantityInput(option, optionValue, onChange)}
        </label>
    `)}
    `;
}